import React from "react";
import TextBox from "./TextBox";
import "./Pagination.css";
import CommonDropDown from "./DropDown/CommonDropDown";

type Props = {
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageCount: number;
  gotoPage: (page: number) => void;
  nextPage: () => void;
  previousPage: () => void;
  pageIndex: number;
  style?: React.CSSProperties;
};

export default function Pagination({
  canPreviousPage,
  canNextPage,
  pageCount,
  gotoPage,
  nextPage,
  previousPage,
  pageIndex,
  style = {},
}: Props) {
  const options = [];
  for (let i = 0; i < pageCount; i++) {
    options.push(i);
  }
  return (
    <div className="pagination" style={{ ...style }}>
      <button onClick={previousPage} disabled={!canPreviousPage} className="pagination-button">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.66669 0L0.666687 8L8.66669 16V0Z" fill={canPreviousPage?"#707070": "#C2C2C2"} />
        </svg>
      </button>
      <span
        style={{
          marginLeft: 16,
          marginRight: 8,
          lineHeight: "32px",
        }}
      >
        {"Page"}
      </span>
      <CommonDropDown
        id={"pagination-selector"}
        value={pageIndex}
        onChange={gotoPage}
        dropDirection={"up"}
        dropDownDisplayValues={
          options.map((option) => ({
            display: `${option+1}`,
            value: option,
            disabled: false,
          }))
        }
        style={{
          width: 73,
          height: 32,
        }}
      />
      <span
        style={{
          marginLeft: 8,
          marginRight: 16,
          lineHeight: "32px",
        }}
      >{`of ${pageCount}`}</span>
      {/* <TextBox
        name="Page"
        value={pageIndex + 1}
        onChange={(page) => gotoPage((page as number) - 1)}
        style={{
          height: "none",
          width: "50px",
          margin: "0px 2px 0px 2px",
        }}
        isInteger={true}
      />
      <span
        style={{
          width: "36px",
          lineHeight: "36px",
        }}
      >{`of ${pageCount}`}</span> */}
      <button onClick={nextPage} disabled={!canNextPage} className="pagination-button">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.333374 0L8.33337 8L0.333374 16V0Z" fill={canNextPage?"#707070": "#C2C2C2"}  />
        </svg>
      </button>
    </div>
  );
}
